<template>
  <div class="pages-tables " id="pages-tables">
    <div class="waterMask" id="watermark"></div>
    <div class="rolling-table meal-table" :class="`meal-table_${key}`" ref="tableBox" :style="{overflow: !yList || !yList.length ? 'auto' : 'none'}">
      <table class="table" id="table" cellpadding="0" cellspacing="0" ref="rollingTable">
        <thead>
        <tr v-for="(x,i) in xList" :key="i">
          <th
            class="rows"
            v-for="(l,index) in x"
            :key="index"
            :colspan="l.colspan"
            :rowspan="l.rowspan">
            <div :style="{width: `${widthInfo[l.field_name]}px`}" class="table-header-container">
              {{l.name}}
            </div>

          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(l,i) in yList" :key="i + 'a'">
          <template v-for="(x, colIdx) in xField">
            <td
              v-for="(ll,yKey) in l"
              :key="yKey"
              v-if="x === yKey">
              <div :style="{width: `${widthInfo[yKey]}px`}" class="table-row-container">

                <div v-if="xList[0][colIdx] && needHandleTypes.includes(xList[0][colIdx].type)">
                  <div v-if="xList[0][colIdx].type === FORM_ITEM__IMAGE" class="table-image-container">
                    <van-image
                      v-for="(img, idx) in yList[i][yKey]"
                      class="image__list-item"
                      :key="img.id"
                      v-if="img.imgUrl"
                      width="30"
                      height="30"
                      @click="previewImage(idx, yList[i][yKey])"
                      :src="img.imgUrl"
                      radius="6"
                      fit="cover">
                      <template v-slot:loading>
                        <van-loading
                          type="spinner"
                          size="20">
                        </van-loading>
                      </template>
                    </van-image>
                  </div>
                  <div v-if="xList[0][colIdx].type === FORM_ITEM__ATTACHMENT" class="table-att-container">
                    <div v-for="(file, idx) in yList[i][yKey]">
                      <div class="file__icon">
                        <svg class="icon" aria-hidden="true">
                          <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                        </svg>
                      </div>
                      <div class="file__info">
                        <div class="file__info-name">
                          {{file.fileName}}
                        </div>
                        <div class="file__info-bottom">

                          <div class="file__info-size">
                            {{file.fileSize}}KB
                          </div>
                          <div class="file__info-handle">
                            <div
                              class="handle-button"
                              @click.stop.prevent.left="previewFile(file)">
                              预览
                            </div>
                            <div class="divider"></div>
                            <div
                              class="handle-button"
                              @click.stop.prevent.left="downloadFile(file)">
                              下载
                            </div>
                            <div class="divider"></div>
                            <div
                              class="handle-button"
                              @click="openFileAccessRecords(file.fileUrl)">
                              访问记录
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="xList[0][colIdx].type === FORM_ITEM__SIGNATURE">
                    <el-image class="sign-image" v-if="yList[i][yKey]" :src="yList[i][yKey]"></el-image>
                    <div v-else>
                      暂无数据
                    </div>
                  </div>
                </div>
                <div v-else>
                  {{ yList[i][yKey]}}
                </div>
              </div>
            </td>
          </template>
        </tr>
        </tbody>
        <tr></tr>
      </table>
      <div v-if="!yList || !yList.length" style="text-align: center; padding: 20px">
        暂无数据
      </div>
    </div>

    <!--访问记录-->
    <file-access-records
      ref="fileAccessRecords"
      popupHeight="90%"
      overlay
      position="bottom"
    ></file-access-records>

    <file-preview-popup
      ref="filePreviewPopup"
      popupHeight="90%"
      overlay
      position="bottom"
    ></file-preview-popup>
  </div>
</template>
<script>
  import {createIScroller, refreshScroller} from "./iscrollTable";
  import {FORM_ITEM__IMAGE, FORM_ITEM__ATTACHMENT, FORM_ITEM__SIGNATURE} from "../../RyForm/types";
  import {ImagePreview} from 'vant'
  import {fileType2FileImage} from "../../../assets/js/Untis";
  import FileAccessRecords from "../mix_form/FileAccessRecords";
  import FilePreviewPopup from "../mix_form/FilePreviewPopup";
  import {uuid} from "../../RyForm/utils";

  // 需要固定首列 <th class="rows " :class="{'cross': index == 0 && i == 0}"
  // v-if="x === yKey" :class="{'cols': yKey == xField[0]}">
  export default {
    props: {
      xList: {
        type: Array,
        default: () => []
      },
      xField: {
        type: Array,
        default: () => []
      },
      yList: {
        type: Array,
        default: () => []
      },
      widthInfo: Object
    },
    data() {
      return {
        maxHeight: '100%',
        scroll: {
          scroller: null
        },
        FORM_ITEM__SIGNATURE,
        FORM_ITEM__IMAGE,
        FORM_ITEM__ATTACHMENT,
        needHandleTypes: [],
        downloadEle: null,
        key: uuid(),
        /*

        xList: [
          [
            {
              field_name: "statis_date",
              name: "第一行合并3行1列",
              colspan: 1, //指定单元格 横向 跨越的 列数
              rowspan: 3, //指定单元格 纵向 跨越的 行数
            },
            {
              field_name: "custom_field",
              name: "第一行合并2列",
              colspan: 2,
              rowspan: 1,
            },
            {
              field_name: "custom_field",
              name: "第一行合并2列",
              colspan: 2,
              rowspan: 1,
            },
            {
              field_name: "custom_field",
              name: "第一行合并3列",
              colspan: 3,
              rowspan: 1,
            },
          ],
          [
            {
              field_name: "custom_field",
              name: "第二行日期",
              colspan: 1, //指定单元格 横向 跨越的 列数
              rowspan: 1, //指定单元格 纵向 跨越的 行数
            },
            {
              field_name: "custom_field",
              name: "第二行日期合并2列",
              colspan: 2,
              rowspan: 1,
            },
            {
              field_name: "custom_field",
              name: "第二行日期合并2列",
              colspan: 2,
              rowspan: 1,
            },
            {
              field_name: "custom_field",
              name: "第二行日期合并3列",
              colspan: 3,
              rowspan: 1,
            },
          ],
          [
            {
              field_name: "area_name",
              name: "第三行当月新增",
              colspan: 1,  //指定单元格 横向 跨越的 列数
              rowspan: 1, //指定单元格 纵向 跨越的 行数
            },
            {
              field_name: "area_name1",
              name: "第三行当月新增1",
              colspan: 1,
              rowspan: 1,
            },
            {
              field_name: "area_name2",
              name: "第三行当月新增2",
              colspan: 1,
              rowspan: 1,
            },
            {
              field_name: "area_name3",
              name: "第三行当月新增3",
              colspan: 1,
              rowspan: 1,
            },
            {
              field_name: "area_name4",
              name: "第三行当月新增4",
              colspan: 1,
              rowspan: 1,
            },
            {
              field_name: "area_name5",
              name: "第三行当月新增5",
              colspan: 1,
              rowspan: 1,
            },
            {
              field_name: "area_name6",
              name: "第三行当月新增6",
              colspan: 1,
              rowspan: 1,
            },
          ],
        ],
        xField: ['statis_date', 'area_name', "area_name1", "area_name2", "area_name3", "area_name4", "area_name5", "area_name6",],
        yList: [
          {
            area_name: "新增数据开始",
            area_name1: "新增数据开始1",
            area_name2: "新增数据开始2",
            area_name3: "新增数据开始3",
            area_name4: "新增数据开始4",
            area_name5: "新增数据开始5",
            area_name6: "新增数据开始6",
            statis_date: 100007,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据",
            area_name1: "新增数据1",
            area_name2: "新增数据2",
            area_name3: "新增数据3",
            area_name4: "新增数据4",
            area_name5: "新增数据5",
            area_name6: "新增数据6",
            statis_date: 201807,
          },
          {
            area_name: "新增数据最后",
            area_name1: "新增数据最后1",
            area_name2: "新增数据最后2",
            area_name3: "新增数据最后3",
            area_name4: "新增数据最后4",
            area_name5: "新增数据最后5",
            area_name6: "新增数据最后6",
            statis_date: 222222,
          }
        ]

        */
      }
    },
    components: {
      FileAccessRecords,
      FilePreviewPopup
    },
    created() {
      this.needHandleTypes = [
        FORM_ITEM__SIGNATURE,
        FORM_ITEM__IMAGE,
        FORM_ITEM__ATTACHMENT
      ]

      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')
    },
    mounted() {
      this.maxHeight = window.screen.height
      this.scroll.scroller = createIScroller(`.meal-table_${this.key}`);
      // addWaterMarker(document.getElementById('watermark'))
    },
    methods: {

      // 预览图片
      previewImage(idx, imgArr) {
        if (window.isLark) {
          this.$tt.ready(() => {

            const urls = imgArr.map(item => item.imgUrl)
            this.$tt.biz.util.previewImage({
              urls,
              current: urls[idx]
            });

          })

        } else {
          ImagePreview({
            images: imgArr.map(item => item.imgUrl),
            startPosition: idx
          })
        }
      },

      // 下载文件
      downloadFile(file) {
        this.downloadEle.setAttribute('download', file.fileName)
        this.downloadEle.setAttribute('href', file.fileUrl)
        this.downloadEle.click()
      },

      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },
      previewFile(file) {

        if (this.$refs.filePreviewPopup) {
          this.$refs.filePreviewPopup.open(file, 'FLOW_FORM')
        }
      },

      openFileAccessRecords(fileUrl) {
        if (this.$refs.fileAccessRecords) {
          this.$refs.fileAccessRecords.open(fileUrl)
        }
      },
    }
  }

</script>
<style lang="less">
  .pages-tables {
    -webkit-overflow-scrolling: touch; // ios滑动顺畅
    position: relative;

    .rolling-table {
      height: 100%;
      max-height: 300px;
      font-size: 12px;
      color: #86939a;
      background-color: #fff;
      width: 100%;
      -webkit-overflow-scrolling: touch;
      position: relative;
      top: 0;
      /*overflow: auto;*/

      .table-header-container {

      }

      .table-row-container {
        text-align: left;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        white-space: pre-wrap;
        line-height: 20px;
      }

      .table-image-container {
        display: flex;
        flex-wrap: wrap;

        .van-image {
          margin: 5px;
        }
      }

      .table-att-container {

        > div {
          list-style: none;
          width: calc(100% - 10px);
          min-height: 40px;
          margin: 5px;
          display: flex;
          position: relative;
          border-bottom: 1px solid #e6e6e6;


          > .file__icon {
            text-align: center;

            .icon {
              width: 30px;
              height: 30px;
              vertical-align: -0.15em;
              fill: currentColor;
              overflow: hidden;
              margin-right: 10px;
              margin-top: 5px;
            }
          }

          > .file__info {
            width: calc(100% - 40px);
            display: flex;
            flex-direction: column;

            > .file__info-name {
              line-height: 20px;
              color: #495060;
              font-size: 13px;
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-wrap: break-word;
            }

            > .file__info-bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;

              > .file__info-size {
                height: 20px;
                line-height: 20px;
                font-size: 11px;
                color: #909399;
              }

              > .file__info-handle {
                display: flex;
                align-items: center;

                .divider {
                  height: 16px;
                  width: 1px;
                  background-color: #e6e6e6;
                  margin: 0 5px;
                }
              }
            }
          }
        }
      }
      .sign-image {
        width: 100px;
        height: 59px;
      }
    }

    .rows {
      position: relative;
      z-index: 3;
    }

    .cross {
      position: relative;
      z-index: 5;
    }

    table td {
      border: 0 solid #000;
      font-size: 12px;
    }

    ::-webkit-scrollbar {
      display: none;
    }

    table {
      //   border-collapse: collapse; //去掉重复的border
      color: #86939e;
      font-size: 12px;
      min-height: 100%;
      text-align: left;
      border-collapse: separate;
      border-spacing: 0;

      td {
        border-bottom: 1px solid #eee;
        white-space: nowrap;
        padding: 0 5px;
        border-right: 1px solid #eee;

        &:last-child {
          border-right: none;
        }
      }

      th {
        color: #43484d;
        white-space: nowrap;
        background-color: #f3f4f6;
        padding: 10px;
        border-right: 1px solid #ffffff;

        &:last-child {
          border-right: none;
        }
      }
    }

    table tbody tr:nth-child(odd) {
      background: #ffffff;
    }

    table tbody tr:nth-child(even) {
      background: rgb(248, 248, 248);
    }

    tr {
      position: relative;
      background-color: #fff;

      &:nth-of-type(odd) {
        td {
          // background-color: pink;
        }
      }
    }
  }

</style>